/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-16 14:11:09
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:33:19
 */
/* eslint-disable react-hooks/exhaustive-deps */
import { CaretDownFilled, SearchOutlined } from "@ant-design/icons";
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import "moment/locale/zh-cn";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { FactoryParams } from "../../services/factory";
import { ThemeContext } from "../../theme/theme";
import { getAreaListAysc } from "./FactorySlice";

export const FactoryQuerys = (props: {
  onValueChange: (queries: FactoryParams) => void;
}): ReactElement => {
  const [form] = Form.useForm();

  const theme = useContext(ThemeContext);

  const dispatch = useDispatch<AppDispatch>();

  const [area, setArea] = useState<any[]>([]);

  useEffect(() => {
    dispatch(getAreaListAysc())
      .then(unwrapResult)
      .then((ss) => {
        setArea(ss);
      })
      .catch(() => {
        //
      });
  }, []);

  return (
    <Form form={form} onFinish={(values) => props.onValueChange(values)}>
      <Row
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='osName' noStyle>
            <Input
              autoComplete='off'
              placeholder='卫健委(局)名称'
              style={{ width: 200 }}
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
              allowClear
            />
          </Form.Item>
          <Form.Item name='regionCode' noStyle>
            <Select
              suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              allowClear
              style={{ width: 220 }}
              placeholder='请选择辖区'
              onChange={form.submit}
            >
              {area.map((s) => (
                <Select.Option key={s.regionCode} value={s.regionCode}>
                  {s.regionName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Space>
        <Col>
          <Button
            type='primary'
            onClick={() => props.onValueChange(form.getFieldsValue())}
          >
            查询
          </Button>
        </Col>
      </Row>
    </Form>
  )
};
